import React from 'react';
import AppBar from '../../../../components/AppBar';
import Layout from '../../../../components/Layout';
import TabsLinks from '../../../../components/TabsLinks';
import { paths } from '../../../../routes';
import { StyledSkills, StyledSkillsContent } from './styled';
import { ApiSkills } from '../../../../api/skills';
import FormSkills from '../../../../forms/FormSkills';
import { useApi } from '../../../../hooks/useApi';
import Typography from '../../../../components/Typography';
import useTheme from '../../../../hooks/useTheme';
import Loader from '../../../../components/Loader';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Skills = () => {
    const { t } = useTranslation()
    const theme = useTheme();

    // Setup request
    const [{ data: skills, loading: skillsLoading }, getSkills] = useApi(ApiSkills.get);
    const [{ loading: skillsCreateLoading }, addSkill] = useApi(ApiSkills.create, { manual: true });
    const [{ loading: skillsDeleteLoading }, deleteSkill] = useApi(ApiSkills.delete, { manual: true });

    const handleAddSkill = reset => async ({ skill }) => {
        const res = await addSkill({
            name: skill.trim()
        })
        if (res?.data) {
            toast.success(t('Umiejętność została dodana'));
            await getSkills();
            reset();
        }
    }

    const handleDeleteSkill = async ({ id }) => {
        if (skills.length > 1) {
            const res = await deleteSkill(id);
            if (res?.data) {
                toast.success(t('Umiejętność została usunięta'));
                getSkills();
            }
        }
    }

    return (
        <StyledSkills>
            <AppBar>
                <Typography
                    font={theme.fonts.mulishRegular}
                    as="h2"
                >
                    {t("Panel administracyjny")}
                </Typography>
            </AppBar>
            <TabsLinks
                tabs={[{
                    to: paths.skills,
                    name: t('Umiejętności')
                }]}
            />
            <Layout>
                <StyledSkillsContent>
                    {skills && (
                        <FormSkills
                            skills={skills}
                            loading={skillsLoading || skillsCreateLoading || skillsDeleteLoading}
                            onSubmit={handleAddSkill}
                            onClickDelete={handleDeleteSkill}
                        />
                    )}
                </StyledSkillsContent>
            </Layout>
            <Loader show={skillsLoading} />
        </StyledSkills>
    )
}

export default Skills;
